export const Licenses = {
  MUI_X_PREMIUM_KEY:
    "ca1b97872aba38a3e842e6e3452faf32Tz0xMzM4MDYsRT0xODI1MDI3MTk5MDAwLFM9cHJlbWl1bSxMTT1hbm51YWwsUFY9UTEtMjAyNixRPTEsQVQ9bXVsdGksS1Y9Mg==",
};
